import {
  downloadResourcePdf,
  resourcePdfUrl,
  downloadTestFeedback,
  testFeedbackUrl,
  getAssignmentDetails,
} from "../../api/profileApi";

export function findUmbraccoResources(resources, ...requiredTitles) {
  return resources.filter((obj) => requiredTitles.includes(obj.title));
}

export function isiOSDevice() {
  return (
    [
      "iPad Simulator",
      "iPhone Simulator",
      "iPod Simulator",
      "iPad",
      "iPhone",
      "iPod",
    ].includes(navigator.platform) ||
    // iPad on iOS 13 detection
    (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  );
}

export function isDownloadAttrSupported() {
  return !isiOSDevice() && "download" in document.createElement("a");
}

export function forceDownload(response, filename) {
  const link = document.createElement("a");
  // eslint-disable-next-line no-undef
  const blob = new Blob([response.data], {
    type: "application/pdf",
  });
  if (isDownloadAttrSupported()) {
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    link.click();
  } else {
    const url = window.URL.createObjectURL(blob);
    window.open(url, "_blank");
  }
}

export async function downloadFeedback(testName, fileName) {
  if (isDownloadAttrSupported()) {
    return downloadTestFeedback(testName).then((response) =>
      forceDownload(response, fileName)
    );
  }
  return window.open(testFeedbackUrl(testName), "_blank");
}

export async function downloadAssignmentDetails() {
  getAssignmentDetails().then((response) => {
    if (isDownloadAttrSupported()) {
      return forceDownload(response, "Assignment Details");
    }
    const link = document.createElement("a");
    // eslint-disable-next-line no-undef
    const blob = new Blob([response.data], {
      type: "application/pdf",
    });

    link.href = window.URL.createObjectURL(blob);
    link.download = `Assignment Details.pdf`;
    return link.click();
  });
}

export async function resourcePdfDownload(
  formName,
  filename,
  complete = false
) {
  if (isDownloadAttrSupported()) {
    return downloadResourcePdf(formName, complete).then((response) =>
      forceDownload(response, filename)
    );
  }
  return window.open(resourcePdfUrl(formName, complete), "_blank");
}
